export const LOADING_NOTIFICATION_SEGMENT = "LOADING_NOTIFICATION_SEGMENT";
export const SAVE_LOADING_NOTIFICATION_SEGMENT = "SAVE_LOADING_NOTIFICATION_SEGMENT";
export const GET_NOTIFICATION_SEGMENT = "GET_NOTIFICATION_SEGMENT";
export const FORM_FAIL = "FORM_FAIL";
export const NOTIFICATION_SEGMENT_FAIL = "NOTIFICATION_SEGMENT_FAIL";
export const LOADING_NOTIFICATION_SEGMENT_BY_ID = "LOADING_NOTIFICATION_SEGMENT_BY_ID";
export const GET_NOTIFICATION_SEGMENT_BY_ID = "GET_NOTIFICATION_SEGMENT_BY_ID";